import React, { FC } from "react";
import { faCheck } from "@fortawesome/pro-regular-svg-icons/faCheck";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export const Check: FC<Omit<FontAwesomeIconProps, "icon">> = (props) => (
  <FontAwesomeIcon icon={faCheck} {...props} />
);
